import type { ToolStatus } from './tools';

const LABELS: Record<ToolStatus, { label: string; cls: string }> = {
  live: { label: 'Live', cls: 'live' },
  beta: { label: 'Beta', cls: 'beta' },
  soon: { label: 'Coming soon', cls: 'soon' },
};

export function StatusChip({ status }: { status: ToolStatus }) {
  const s = LABELS[status];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: '0.02em',
        color: status === 'soon' ? 'rgba(14,14,14,.55)' : 'var(--ink)',
      }}
    >
      <span className={`dot ${s.cls}`} />
      {s.label}
    </span>
  );
}
